import React from 'react';

export const NotifyContext = React.createContext();